import React from 'react'
import Layout from '../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const WetStretchmeasurementsystem = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1500,        // ✅ slower transition (2 seconds)
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500 // ✅ stays 3 seconds before next slide (optional)
  };

  const images = [
    'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpulpinstrument%2Fimg%2F1772782315328_wet.png?alt=media&token=3d08a128-bdda-40a2-910d-5cc93a55b31d',
    'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpulpinstrument%2Fimg%2F1772782315328_wet.png?alt=media&token=3d08a128-bdda-40a2-910d-5cc93a55b31d'
  ];

  return (
    <Layout>
      <div className="bread">
        <ul className="collapsed">
          <li><a href="/">Home</a></li>
          <li><a href="/paperTesting">Paper Testing</a></li>
        </ul>
      </div>
      <div className="container">
        <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
          <h1>Wet Stretch Measurement System</h1>
        </div>
      </div>
      <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-8">
              <div className="portfolio-details-slider swiper">
                <Slider {...settings}>
                  {images.map((src, index) => (
                    <div className="swiper-slide" key={index}>
                      <div className="img" style={{ alignItems: 'center' }}>
                        <img src={src} alt="" className="responsive" />
                      </div>
                    </div>
                  ))}
                </Slider>
                <div className="swiper-pagination"></div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                <h3 className='pageheading'>Wet Stretch Measurement System</h3>
                <div className='descriptionHead' style={{ textAlign: 'justify' }}>
                  <p>
                    As machine speed in paper coating and converting operation increases, paper are stretched more
                    than before. In the printing process overstretching of the paper may result in misregister problems.
                    Because f this, the paper quality has to be assessed  prior to upgrading and converting. However,
                    Traditional static test methods such as wet tensile stress fail to satisfactorily describe the converting
                    114behavior. What are needed for quality are more detailed test method which give close-to-reality
                    results. These problems can be minimized by WSD Analyzer which is used to measure the wet stretch
                    dynamic of the paper. It reveals the behaviour of paper material during  orienting and impregnating
                    processes. The result provide the information about the composition of paper or liquids such as inks
                    or impregnating resins, so that industries can work on optimization.
                  </p>

                  <a
                    href="mailto:inst@rmc.in?subject=Inquiry about Fiber Potential Online (FPO)"
                    style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                  >
                    More Info
                  </a>
                </div>
              </div>
              <div className="portfolio-description"></div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default WetStretchmeasurementsystem